import { CREATE_SECOND_DELIVERY_BATCH, CREATE_SECOND_DELIVERY_BATCH_FAIL, CREATE_SECOND_DELIVERY_BATCH_SUCCESS, GET_SECOND_DELIVERY_ORDERS, 
    GET_SECOND_DELIVERY_ORDERS_FAIL, 
    GET_SECOND_DELIVERY_ORDERS_SUCCESS } from "../actions/types";

const initialState = {
    isOrdersLoading: false,
    orders: [],
    isLoading: false
}

export default function secondDeliveryReducer(state = initialState, action){
    switch(action.type){
        case GET_SECOND_DELIVERY_ORDERS:
            return {
                ...state,
                orders: initialState.orders,
                isOrdersLoading: true
            }
        case GET_SECOND_DELIVERY_ORDERS_SUCCESS:
            return {
                ...state,
                orders: action.payload,
                isOrdersLoading: false
            }
        case GET_SECOND_DELIVERY_ORDERS_FAIL:
            return {
                ...state,
                isOrdersLoading: false
            }
        case CREATE_SECOND_DELIVERY_BATCH:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_SECOND_DELIVERY_BATCH_SUCCESS:
            return {
                ...state,
                isLoading: false
            }
        case CREATE_SECOND_DELIVERY_BATCH_FAIL:
            return {
                ...state,
                isLoading: false
            }
        default:
            return state;
    }
}